// CssTemplate.tsx
const getCssTemplate = (
    mainColor: string, 
    darkColor: string, 
    mainRgb: [number, number, number], 
    darkRgb: [number, number, number],
    tooltipTextColor: string = '#ffffff',
    position: { bottom?: string, right?: string } = { bottom: '30px', right: '30px' }
  ): string => {
    const [mainR, mainG, mainB] = mainRgb;
    const [darkR, darkG, darkB] = darkRgb;
  
    return `
  #chatbot-close-window {
      position: absolute;
      top: 0;
      left: 0;
      background: none;
      border: none;
      cursor: pointer;
      padding: 4px 10px;
      line-height: 1;
      color: rgba(255, 255, 255, 0.9);
      transition: all 0.2s ease;
      font-size: 35px;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }
  
  #chatbot-close-window::after {
      content: '×';
      display: block;
      margin: 0;
  }
  
  #chatbot-close-window:hover {
      color: #000;
      transform: scale(1.2);
  }
  
  .scroll-lock {
      overflow: hidden !important;
      position: fixed;
      width: 100%;
      height: 100%;
  }
  
  #chatbot-floating-window {
      display: none;
      position: fixed;
      bottom: ${position.bottom};
      right: ${position.right};
      width: 433px;
      height: 650px;
      background: transparent;
      border: none;
      z-index: 1000;
      opacity: 0;
      transform: scale(0);
      visibility: hidden;
      transition: visibility 0s, opacity 0.2s, transform 0.2s, border-radius 0.2s;
      justify-content: center;
      align-items: center;
      border-radius: 16px; 
      box-shadow: 
          0 10px 25px rgba(0, 0, 0, 0.15),
          0 5px 10px rgba(0, 0, 0, 0.12);
      overflow: hidden;
      transform-origin: bottom right;
  }
  
  #chatbot-floating-window.show {
      visibility: visible;
      display: flex;
      opacity: 1;
      transform: scale(1);
      -webkit-animation: scale-in-br 0.2s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
      animation: scale-in-br 0.2s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  }
  
  #chatbot-floating-window.show.hide {
      -webkit-animation: scale-out-tl 0.2s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
      animation: scale-out-tl 0.2s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
  }
  
  #chatbot-open-window {
      display: flex;
      position: fixed;
      bottom: ${position.bottom};
      right: ${position.right};
      padding: 0;
      border: none;
      border-radius: 100%;
      z-index: 1000;
      color: rgba(255, 255, 255, 1);
      background: linear-gradient(135deg, ${mainColor}, ${darkColor});
      box-shadow: 
          0 0 10px rgba(${mainR}, ${mainG}, ${mainB}, 0.5),
          0 0 20px rgba(${mainR}, ${mainG}, ${mainB}, 0.4),
          0 0 30px rgba(${mainR}, ${mainG}, ${mainB}, 0.3),
          0 0 40px rgba(${mainR}, ${mainG}, ${mainB}, 0.2);
      cursor: pointer;
      align-items: center;
      justify-content: center;
      width: 65px;
      height: 65px;
      min-width: 65px;
      max-width: 65px;
      min-height: 65px;
      max-height: 65px;
      overflow: hidden;
      position: relative;
      box-shadow: 
          0 6px 16px rgba(0, 0, 0, 0.15),
          0 0 10px rgba(${mainR}, ${mainG}, ${mainB}, 0.5),
          0 0 20px rgba(${mainR}, ${mainG}, ${mainB}, 0.3);
      transition: opacity 0.2s ease-in-out, transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.3s ease;
      transform-origin: center;
  }
  
  #chatbot-open-window:hover {
      transform: scale(1.05) translateY(-2px);
      box-shadow: 
          0 8px 20px rgba(0, 0, 0, 0.2),
          0 0 15px rgba(${mainR}, ${mainG}, ${mainB}, 0.6),
          0 0 30px rgba(${mainR}, ${mainG}, ${mainB}, 0.4);
  }
  
  #chatbot-open-window dotlottie-player {
      width: 60px !important; /* Slightly bigger animation */
      height: 60px !important;
      position: absolute !important;
      /*left: 50% !important;
      top: 50% !important;
      transform: translate(-50%, -50%) !important;*/
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
  }
  
  #chatbot-iframe-content {
      width: 100%;
      height: 100%;
      border: none;
      border-radius: 16px;
  }
  
  #chatbot-tooltip {
      position: fixed;
      background: linear-gradient(135deg, ${mainColor}, ${darkColor});
      border: 2px solid ${mainColor};
      box-shadow: 
          0 0 10px rgba(${mainR}, ${mainG}, ${mainB}, 0.5),
          0 0 20px rgba(${mainR}, ${mainG}, ${mainB}, 0.4),
          0 0 30px rgba(${mainR}, ${mainG}, ${mainB}, 0.3),
          0 0 40px rgba(${mainR}, ${mainG}, ${mainB}, 0.2);
      border-radius: 20px;
      padding: 12px 18px;
      font-size: 18px;
      color: ${tooltipTextColor};
      font-weight: 500;
      right: 103px;
      bottom: 40px;
      z-index: 9999;
      opacity: 0;
      visibility: hidden;
      transform-origin: bottom right;
      min-width: 220px;
      max-width: 300px;
      line-height: 1.4;
      word-wrap: break-word;
      white-space: normal;
      animation: tooltipPulse 2s infinite ease-in-out;
      transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }
  
  #chatbot-tooltip::after {
      content: '';
      position: absolute;
      right: -14px;
      bottom: 15px;
      border-width: 7px;
      border-style: solid;
      border-color: transparent transparent transparent ${mainColor};
      filter: drop-shadow(2px 0px 2px rgba(0, 0, 0, 0.1));
  }
  
  #chatbot-tooltip.show {
      opacity: 1;
      visibility: visible;
      animation: tooltipEntrance 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }
  
  #chatbot-tooltip-close {
      position: absolute;
      top: -10px;
      right: -10px;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border: none;
      background: rgba(255, 255, 255, 0.9);
      color: #444;
      font-size: 16px;
      line-height: 1;
      cursor: pointer;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      transform-origin: center;
      transition: all 0.2s ease;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
      z-index: 10;
  }
  
  #chatbot-tooltip-close:hover {
      background: rgba(255, 255, 255, 0.95);
      transform: scale(1.3);
  }
  
  #chatbot-controls {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 42px;
      background: linear-gradient(to bottom, 
                   ${darkColor} 0%, 
                   rgba(${darkR}, ${darkG}, ${darkB}, 0.95) 30%,
                   rgba(${Math.floor((darkR + mainR) / 2)}, ${Math.floor((darkG + mainG) / 2)}, ${Math.floor((darkB + mainB) / 2)}, 0.9) 50%,
                   rgba(${Math.floor((darkR + mainR * 2) / 3)}, ${Math.floor((darkG + mainG * 2) / 3)}, ${Math.floor((darkB + mainB * 2) / 3)}, 0.7) 70%,
                   rgba(${mainR}, ${mainG}, ${mainB}, 0.4) 85%,
                   rgba(${mainR}, ${mainG}, ${mainB}, 0) 100%);
      border-radius: 16px 16px 0 0;
      border: none;
      box-shadow: none;
      overflow: hidden;
  }
  
  #chatbot-controls.fullscreen {
      border-radius: 0;
      background: linear-gradient(to bottom, 
                  ${darkColor} 0%, 
                  rgba(${darkR}, ${darkG}, ${darkB}, 0.95) 40%,
                  rgba(${Math.floor((darkR + mainR) / 2)}, ${Math.floor((darkG + mainG) / 2)}, ${Math.floor((darkB + mainB) / 2)}, 0.9) 60%,
                  rgba(${Math.floor((darkR + mainR * 2) / 3)}, ${Math.floor((darkG + mainG * 2) / 3)}, ${Math.floor((darkB + mainB * 2) / 3)}, 0.7) 80%,
                  rgba(${mainR}, ${mainG}, ${mainB}, 0) 100%);
      height: 45px;
  }
  
  #chatbot-dragbar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
  }
  
  .left-controls {
      display: flex;
      align-items: center;
  }
  
  .right-controls {
      display: flex;
      align-items: center;
      padding-right: 8px;
  }
  
  #chatbot-resize {
      background: none;
      border: none;
      cursor: pointer;
      padding: 8px 8px;
      color: rgba(255, 255, 255, 0.9);
      font-size: 20px;
      transition: all 0.2s ease;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }
  
  #chatbot-resize:hover {
      color: #000;
      transform: scale(1.1);
  }
  
  #chatbot-floating-window.fullscreen {
      width: 100% !important;
      height: 100% !important;
      border-radius: 0;
      box-shadow: none;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      bottom: 0 !important;
  }
  
  @media (max-width: 768px) {
      #chatbot-floating-window {
          width: 100%;
          height: 100%;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          border-radius: 0;
          margin: 0;
          padding: 0;
          display: none;
      }
  
      #chatbot-floating-window.show {
          display: flex;
          height: 100%;
          transform: none;
      }
  
      #chatbot-iframe-content {
          width: 100vw;
          height: 100%;
          border-radius: 0;
      }
  
      #chatbot-controls {
          border-radius: 0;
      }
  
      #chatbot-close-window {
          width: 28px;
          height: 28px;
          padding: 8px;
          margin: 8px;
          border: none;
          background-color: #FF0000;
          position: relative;
          border-radius: 5px;
          transition: background-color 0.2s ease;
      }
  
      #chatbot-close-window::before,
      #chatbot-close-window::after {
          content: '';
          position: absolute;
          width: 14px;
          height: 2px;
          background-color: #FFFFFF;
          top: 50%;
          left: 50%;
      }
  
      #chatbot-close-window::before {
          transform: translate(-50%, -50%) rotate(45deg);
      }
  
      #chatbot-close-window::after {
          transform: translate(-50%, -50%) rotate(-45deg);
      }
  
      #chatbot-close-window:hover {
          background-color: #CC0000;
      }
  
      #chatbot-close-window:hover::before,
      #chatbot-close-window:hover::after {
          background-color: #FFFFFF;
      }
  
      #chatbot-open-window {
          bottom: 10px;
          right: 10px;
          padding: 0;
          width: 50px;
          height: 50px;
          min-width: 50px;
          max-width: 50px;
          min-height: 50px;
          max-height: 50px;
          border-radius: 50%;
          align-items: center;
          justify-content: center;
      }
  
      #chatbot-open-window dotlottie-player {
          width: 40px !important;
          height: 40px !important;
      }
  
      #chatbot-tooltip {
          right: 70px;
          bottom: 15px;
          font-size: 12px;
          padding: 6px 12px;
      }
  
      #chatbot-resize {
          display: none;
      }
  }
  
  @media (max-height: 750px) {
      #chatbot-floating-window {
          height: 80vh;
      }
  }
  
  @-webkit-keyframes scale-in-br {
      0% {
          -webkit-transform: scale(0);
          transform: scale(0);
          -webkit-transform-origin: 100% 100%;
          transform-origin: 100% 100%;
          opacity: 0.5;
      }
  
      100% {
          -webkit-transform: scale(1);
          transform: scale(1);
          -webkit-transform-origin: 100% 100%;
          transform-origin: 100% 100%;
          opacity: 1;
      }
  }
  
  @keyframes scale-in-br {
      0% {
          -webkit-transform: scale(0);
          transform: scale(0);
          -webkit-transform-origin: 100% 100%;
          transform-origin: bottom right;
          opacity: 0.5;
      }
  
      100% {
          -webkit-transform: scale(1);
          transform: scale(1);
          -webkit-transform-origin: 100% 100%;
          transform-origin: bottom right;
          opacity: 1;
      }
  }
  
  @-webkit-keyframes scale-out-tl {
      0% {
          -webkit-transform: scale(1);
          transform: scale(1);
          -webkit-transform-origin: 100% 100%;
          transform-origin: 100% 100%;
          opacity: 1;
      }
  
      100% {
          -webkit-transform: scale(0);
          transform: scale(0);
          -webkit-transform-origin: 100% 100%;
          transform-origin: 100% 100%;
          opacity: 1;
      }
  }
  
  @keyframes scale-out-tl {
      0% {
          -webkit-transform: scale(1);
          transform: scale(1);
          -webkit-transform-origin: 100% 100%;
          transform-origin: bottom right;
          border-radius: 10px;
          opacity: 1;
      }
  
      100% {
          -webkit-transform: scale(0);
          transform: scale(0);
          border-radius: 100%;
          -webkit-transform-origin: 100% 100%;
          transform-origin: bottom right;
          opacity: 0;
      }
  }
  
  @keyframes tooltipEntrance {
      0% {
          opacity: 0;
          transform: scale(0.5) translateX(-20px);
      }
      100% {
          opacity: 1;
          transform: scale(1) translateX(0);
      }
  }
  
  @keyframes tooltipPulse {
      0% { transform: scale(1); }
      50% { transform: scale(1.02); }
      100% { transform: scale(1); }
  }
    `;
  };
  
  export default getCssTemplate;